import React from 'react';

import FooterGroups from './groups/footer.groups';
import FooterCerts from './certs/footer.certs';
import FooterLinks from './links/footer.links';
import Link from 'atomic/link/link';
import arrowTop from 'assets/icons/arrow-top.inline.svg';
import './footer.desktop.scss';

const FooterDesktop: React.FC = () => (
    <footer className="footer">
        <div className="container">
            <div className="footer__top">
                <FooterGroups />
                <FooterCerts />
            </div>
            <div className="footer__links-wrapper">
                <FooterLinks />
                <div className="footer__links-top">
                    <Link href="#" className="footer__link">
                        <img src={arrowTop} alt="" className="footer__link-top-icon" />
                        <span>
                            Powrót do góry
                        </span>
                    </Link>
                </div>
            </div>
            <p className="footer__copyright">
                Copyright &copy;
                {` 2007-${(new Date()).getFullYear()} `}
                Opineo.pl
            </p>
        </div>
    </footer>
);

export default FooterDesktop;
